import React from 'react';

const Fentcoin = () => {
  return (
    <div className="text-white text-center max-w-full overflow-x-hidden px-1">
      <pre className="font-mono text-[0.3rem] xxs:text-[0.35rem] xs:text-[0.45rem] sm:text-[0.6rem] md:text-sm lg:text-base whitespace-pre inline-block">
        {`
    
░▒▓██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████▓▒░
░▒▓█▓▒░                                                                                                                   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓████████▓▒░ ░▒▓████████▓▒░ ░▒▓███████▓▒░░ ▒▓████████▓▒ ░░▒▓██████▓▒░   ░▒▓██████▓▒░  ░▒▓█▓▒░ ░▒▓███████▓▒░    ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓█▓▒░        ░▒▓█▓▒░        ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░    ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓█▓▒░        ░▒▓█▓▒░        ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░    ░▒▓█▓▒░        ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓██████▓▒░   ░▒▓██████▓▒░   ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░    ░▒▓█▓▒░        ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓█▓▒░        ░▒▓█▓▒░        ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░    ░▒▓█▓▒░        ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓█▓▒░        ░▒▓█▓▒░        ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░    ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░░▒▓█▓▒░ ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░  ░▒▓█▓▒░        ░▒▓████████▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ░▒▓█▓▒░     ░▒▓██████▓▒░   ░▒▓██████▓▒░  ░▒▓█▓▒░ ░▒▓█▓▒░ ▒▓█▓▒░   ▒▓█▓▒░
░▒▓█▓▒░                                                                                                                   ▒▓█▓▒░
░▒▓██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████▓▒░

`}
      </pre>
    </div>
  );
};

export default Fentcoin;